  
import * as React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    DashboardMenuItem,
    MenuItemLink,
    MenuProps,
} from 'react-admin';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';

import azure_authentications from '../azure_authentications';
import azure_storages from '../azure_storages';
import database_items from '../database_items';
import instances from '../instances';
import jobs from '../jobs';
import projects from '../projects';
import resources from '../resources';
import schedules from '../schedules';
import targets from '../targets';
import environments from '../environments';

import SubMenu from './SubMenu';

type MenuName = 'menuInstances' | 'menuResources' | 'menuSettings';

const Menu = ({ dense = false }: MenuProps) => {
    const [state, setState] = useState({
        menuInstances: true,
        menuResources: true,
        menuSettings: false,
    });
    const classes = useStyles();

    const handleToggle = (menu: MenuName) => {
        setState(state => ({ ...state, [menu]: !state[menu] }));
    };

    return (
        <div className={classes.root}>
            {' '}
            <DashboardMenuItem sidebarIsOpen={true} />
            <MenuItemLink
                to={`/jobs`}
                primaryText="Jobs"
                leftIcon={<jobs.icon />}
                dense={dense}
            />
            <SubMenu
                handleToggle={() => handleToggle('menuInstances')}
                isOpen={state.menuInstances}
                name="Instances"
                icon={<instances.icon />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/instances`}
                    primaryText="Instances"
                    leftIcon={<instances.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/projects`}
                    primaryText="Projects"
                    leftIcon={<projects.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/environments`}
                    primaryText="Environments"
                    leftIcon={<environments.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/schedules`}
                    primaryText="Schedules"
                    leftIcon={<schedules.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/targets`}
                    primaryText="Targets"
                    leftIcon={<targets.icon />}
                    dense={dense}
                />
            </SubMenu>
            <SubMenu
                handleToggle={() => handleToggle('menuResources')}
                isOpen={state.menuResources}
                name="Resources"
                icon={<resources.icon />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/resources`}
                    primaryText="Resources"
                    leftIcon={<resources.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/azure_authentications`}
                    primaryText="Azure authentications"
                    leftIcon={<azure_authentications.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/azure_storages`}
                    primaryText="Azure storages"
                    leftIcon={<azure_storages.icon />}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/database_items`}
                    primaryText="Database items"
                    leftIcon={<database_items.icon />}
                    dense={dense}
                />
            </SubMenu>
            <SubMenu
                handleToggle={() => handleToggle('menuSettings')}
                isOpen={state.menuSettings}
                name="Settings"
                icon={<SettingsIcon />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/users`}
                    primaryText="Users"
                    leftIcon={<PeopleIcon />}
                    dense={dense}
                />
            </SubMenu>
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(1),
    },
}));

export default Menu;